import { apolloClient } from "@/plugins/vue-apollo.js";

const updateUnit = async ( variables) => {
    let responseFromApi = await apolloClient.mutate({
        mutation: require("@/landlord/api/mutations/update_unit.graphql"),
        variables:variables ,
    }).catch((error) => {
        throw error;
    })
    return responseFromApi;

};

export { updateUnit };
